export default "__VITE_ASSET__BKDy8$7m__"